<template>
  <div>
    <CRow>
      <CCol lg="12">
        <CCard>
          <CCardHeader class="d-flex justify-content-between align-items-center">
            <div class="d-flex align-items-center">
              <CIcon name="cil-grid"/> Listado de almacenes
            </div>
            <div>
              <CButton color="twitter" @click="openModal()">
                Nuevo
              </CButton>
            </div>
          </CCardHeader>
          <CCardBody>

            <!-- MODAL -->
            <CModal
              :title="titleModal"
              size="lg"
              :show.sync="flagModal"
            >

              <CForm novalidate>
                <CCardBody>

                  <CInput
                    :value.sync="warehouse.name"
                    :disabled="loadingModal"
                    @keyup.enter="saveWarehouse()"
                    description="Por favor ingresa un nombre."
                    label="Nombre"
                    placeholder="Ingresa un nombre..."
                    required
                    was-validated
                  />

                </CCardBody>
              </CForm>

              <template #footer>

                <div v-if="!loadingModal">
                  <CButton color="primary" @click="saveWarehouse()" class="mr-1 mb-3"><CIcon name="cil-save"/> <span v-text="textButton"></span></CButton>
                </div>
                <div v-else>
                  <CCol xl="3" lg="4" md="6">
                    <CCardBody>
                      <div class="sk-chase">
                        <div class="sk-chase-dot"></div>
                        <div class="sk-chase-dot"></div>
                        <div class="sk-chase-dot"></div>
                        <div class="sk-chase-dot"></div>
                        <div class="sk-chase-dot"></div>
                        <div class="sk-chase-dot"></div>
                      </div>
                    </CCardBody>
                  </CCol>
                </div>

              </template>

            </CModal>

            <ModalLots
              :isVisibleModalLots="flagModalLots"
              :warehouse="warehouseSelect"
              @close-modal-lots="closeModalLots"
            />

            <!-- FILTROS -->
            <CRow>
              <CCol md="3">
                <CInput type="text" label="Código" v-model="filters.code" />
              </CCol>
              <CCol md="3">
                <CInput type="text" label="Nombre" v-model="filters.name" />
              </CCol>
            </CRow>
            <CRow>
              <CCol md="6" class="d-flex align-items-center">
                <CButton color="primary" @click="getWarehouses" class="mr-2" style="width: auto;">
                  <CIcon name="cil-magnifying-glass" /> Buscar
                </CButton>
                <CButton color="info" @click="cleanFilters" class="mr-2" style="width: auto;">
                  <CIcon name="cil-share" /> Limpiar filtros
                </CButton>
                <CButton color="success" @click="downloadExcelWarehouses" style="width: auto;">
                  <CIcon name="cil-spreadsheet" /> Generar Excel
                </CButton>
              </CCol>
            </CRow>
            <br />

            <!-- LISTADO -->
            <TableCustom :items="tableItems" :fields="fields" :loading="loading">

              <!-- BUTTON HISTORIAL -->
              <template #buttonHistory="{item}">
                <BaseButton :modo="'ver'" @click="openModalWarehouses(item)" />
              </template>

              <!-- BUTTON EDIT -->
              <template #buttonEdit="{item}">
                <BaseButton :modo="'editar'" :loading="loadingButtonEdit[item.id]" @click="editModal(item.id)"></BaseButton>
              </template>

              <!-- BUTTON DELETE -->
              <template #buttonDelete="{item}">
                <BaseButton :modo="'eliminar'" @click="deleteWarehouse(item.id, item.name)"></BaseButton>
              </template>

            </TableCustom>

          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>

import Swal from "sweetalert2"
import * as XLSX from 'xlsx';
import {list, save, show, destroy, request} from '@/utils/functions.js'
import ModalLots from './ModalLots.vue';

  export default {
    name: 'WareHouses',
    props: {
      fields: {
        type: Array,
        default () {
          return [
            { key: 'index',         label: '#',        _classes: 'text-center' },
            { key: 'code',          label: 'Código',   _classes: 'text-center' },
            { key: 'name',          label: 'Nombre',   _classes: 'text-center' },

            // Botones de acción
            { key: 'buttonHistory', label: 'Lotes',    _classes: 'text-center', _style:'min-width:20%;' },
            { key: 'buttonEdit',    label: 'Editar',   _classes: 'text-center', _style:'min-width:20%;' },
            { key: 'buttonDelete',  label: 'Eliminar', _classes: 'text-center', _style:'min-width:20%;' },
          ]
        }
      },
    },
    mounted() {
      this.getWarehouses();
    },
    computed: {
      tableItems () { return this.loading ? [] : this.warehouses }
    },
    data () {
      return {
        prefix_list: "warehouses",
        prefix: "warehouse",
        warehouses: [],
        warehouseSelect: null,

        loading: true,
        loadingModal: false,

        warehouse: {
          id: "",
          name: "",
        },
        filters: {
          name  : "",
        },

        //? Modal
        titleModal: "Nuevo almacén",
        textButton: "Guardar",
        flagModal: false,
        flagModalLots: false,
        loadingButtonEdit: {},
      }
    },
    components: {
      ModalLots,
    },
    methods: {

      //* Main Functions
        async getWarehouses(){

          await this.request(async () => {
            const url = this.$store.state.url
            const resp = await list(url + this.prefix_list, this.filters)
            if (resp.status === 200) this.warehouses = resp.data.data || []
            else this.warehouses = []
          }, { loadingKey: "loading" })

        },
        async saveWarehouse(){

          await this.request(async () => {

            const url = this.$store.state.url
            const data = this.getSetData(this.warehouse);
            const resp = await save(url + this.prefix, data, this.warehouse.id)

            if (resp.status === 200) {
              await this.getWarehouses()
              Swal.fire("Alerta", resp.data.message, "success")
              this.flagModal = false
            }

          }, { loadingKey: "loadingModal" })

        },
        async editModal(id){

          this.flagModal = true
          this.titleModal = "Modificar Almacén"
          this.textButton = "Modificar"
          this.loadingModal = true

          try {
            const url = this.$store.state.url
            const resp = await show(url + this.prefix + `/${id}`)
            if (resp.status === 200) {
              const d = resp?.data?.data || {}
              this.warehouse = {
                id: d.id || "",
                name: d.name || "",
              }
              this.$set(this.loadingButtonEdit, id, false)
            }
          } catch (e) {
            // ya maneja Swal arriba
          } finally {
            this.loadingModal = false
          }

        },
        async deleteWarehouse(id, name){

          const res = await Swal.fire({
            title: "¿Está seguro?",
            html: `Se eliminará el almacén '${name}'.`,
            icon: "warning",
            confirmButtonText: "Sí, eliminar",
            showCancelButton: true,
            cancelButtonText: "Cancelar"
          })

          if (!res.value) return

          await this.request(async () => {

            const url = this.$store.state.url
            const resp = await destroy(url + this.prefix + `/${id}`)

            if (resp.status === 200) {
              await this.getWarehouses()
              Swal.fire("Alerta", resp.data.message, "success")
            }

          })

        },
        downloadExcelWarehouses() {

          const data = (this.warehouses || []).map(c => ({
            'Código': c.code || '',
            'Nombre': c.name || '',
          }))

          const ws = XLSX.utils.json_to_sheet(data)
          const range = XLSX.utils.decode_range(ws['!ref'] || 'A1:A1')

          for (let c = range.s.c; c <= range.e.c; c++) {
            const addr = XLSX.utils.encode_cell({ r: 0, c })
            if (ws[addr]) {
              ws[addr].s = {
                font: { bold: true },
                alignment: { horizontal: "center" }
              }
            }
          }

          const wb = XLSX.utils.book_new()
          XLSX.utils.book_append_sheet(wb, ws, 'Almacenes')
          XLSX.writeFile(wb, 'reporte_almacenes.xlsx')

        },

      //* Secondary Functions
        request,
        getSetData(data){

          let formData = new FormData();

          formData.append('name', data.name);

          return formData;

        },
        cleanFilters() {
          this.filters = { document:"", name:"", type:"" }
          this.getWarehouses()
        },

        //? Modal
        openModalWarehouses(warehouseSelect){
          this.warehouseSelect = warehouseSelect;
          this.flagModalLots = true;
        },
        closeModalLots(){
          this.flagModalLots = false;
        },
        openModal(){ this.cleanModal(); this.flagModal = true },
        cleanModal(){
          this.warehouse  = { id:"", document:"", name:"" }
          this.titleModal = "Nuevo Almacén";
          this.textButton = "Guardar";
        },

    }
  }

</script>

<style src="spinkit/spinkit.min.css"></style>
